export const DATE_IS_STILL = 'nadal';